<template>
  <v-layout>
    <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
      <!-- <img :src="imageUrl" height="100" v-if="imageUrl!=''"> -->
      <v-text-field
        :label="label"
        @click="pickFile"
        v-model="imageName"
        prepend-icon="attach_file"
        :placeholder="hint"
        :error-messages="errorMessages"
      ></v-text-field>
      <input type="file" style="display: none" ref="image" accept="*" @change="onFilePicked" />
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: ["image", "label", "errorMessages", "hint"],
  data: () => ({
    title: "Image Upload",
    dialog: false,
    imageName: "",
    imageUrl: "",
    imageFile: ""
  }),
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      const file = files[0];

      if (file !== undefined) {
        if (file.size > 1024 * 1024 * 2) {
          e.target.value = "";
          this.imageName = "";
          this.imageFile = "";
          this.imageUrl = "";      

          this.errorMessages = "El fichero no puede ser mayor a 2 MB";
          return;
          
        } else {
          this.errorMessages = "";
        }

        this.imageName = file.name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }

        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener(
          "load",
          () => {
            this.imageUrl = fr.result;
            this.imageFile = file; // this is an image file that can be sent to server...
            this.$emit("input", {
              imageFile: this.imageFile,
              imageName: this.imageName,
              imageUrl: this.imageUrl
            });
          },
          { passive: true }
        );
      } else {
        e.target.value = "";
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";        
      }
    }
  }
};
</script>

